import ChartComponent from "./ChartComponent";
import React from 'react';
import * as d3 from 'd3';

const DivergingBarChart = ({ data, width, xScale, yScale, topMargin, metric = 'relative' }) => {
    function draw(chart) {
        const format = d3.format(metric === "absolute" ? "+,d" : "+,.0%");
        const tickFormat = metric === "absolute" ? d3.formatPrefix("+.1", 1e6) : format;

        chart.append("g")
            .selectAll("rect")
            .data(data)
            .join("rect")
            .attr("fill", d => d3.schemeSet1[d.value > 0 ? 1 : 0])
            .attr("x", d => xScale(Math.min(d.value, 0)))
            .attr("y", (_, i) => yScale(i))
            .attr("width", d => Math.abs(xScale(d.value) - xScale(0)))
            .attr("height", yScale.bandwidth());

        chart.append("g")
            .attr("font-family", "sans-serif")
            .attr("font-size", 10)
            .selectAll("text")
            .data(data)
            .join("text")
            .attr("text-anchor", d => d.value < 0 ? "end" : "start")
            .attr("x", d => xScale(d.value) + Math.sign(d.value - 0) * 4)
            .attr("y", (_, i) => yScale(i) + yScale.bandwidth() / 2)
            .attr("dy", "0.35em")
            .text(d => format(d.value));

        const xAxis = g => g.attr("transform", `translate(0,${topMargin})`)
            .call(d3.axisTop(xScale).ticks(width / 80).tickFormat(tickFormat))
            .call(g => g.select(".domain").remove())

        const yAxis = g => g.attr("transform", `translate(${xScale(0)},0)`)
            .call(d3.axisLeft(yScale).tickFormat(i => data[i].name).tickSize(0).tickPadding(6))
            .call(g => g.selectAll(".tick text").filter(i => data[i].value < 0)
                .attr("text-anchor", "start")
                .attr("x", 6))

        chart.append("g")
            .call(xAxis);

        chart.append("g")
            .call(yAxis);
    }

    return <ChartComponent draw={draw} />;
}

export default DivergingBarChart
